export const DEV = process.env.NODE_ENV !== 'production';
